(() => {
  const init = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const controller = new AbortController();
    const route = window.Shopify?.routes?.root || '/';
    let busy = false;
    const orderKey = 'tsyrk-cart-line-order';
    let lineOrder = [];
    try { lineOrder = JSON.parse(sessionStorage.getItem(orderKey) || '[]'); } catch {}
    const saveOrder = () => { try { sessionStorage.setItem(orderKey, JSON.stringify(lineOrder)); } catch {} };
    const restoreOrder = () => {
      const rows = [...root.querySelectorAll('[data-cart-item]')];
      lineOrder = lineOrder.filter(key => rows.some(row => row.dataset.key === key));
      rows.forEach(row => { if (!lineOrder.includes(row.dataset.key)) lineOrder.push(row.dataset.key); });
      const subtotal = root.querySelector('.tsyrk-cart__subtotal');
      lineOrder.forEach(key => { const row = rows.find(row => row.dataset.key === key); if (row && subtotal) subtotal.before(row); });
      saveOrder();
    };
    const json = async (path, body) => {
      const response = await fetch(route + path, {
        method: body ? 'POST' : 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        ...(body ? { body: JSON.stringify(body) } : {}), signal: controller.signal
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Unable to update your bag. Please try again.');
      return result;
    };
    const itemData = (row) => JSON.parse(row.querySelector('[data-cart-item-data]').textContent);
    const refresh = async () => {
      const url = new URL(location.href);
      url.searchParams.set('sections', root.dataset.sectionId);
      const response = await fetch(url, { signal: controller.signal });
      if (!response.ok) throw new Error('The bag changed, but could not refresh. Please reload the page.');
      const sections = await response.json();
      const parsed = new DOMParser().parseFromString(sections[root.dataset.sectionId] || '', 'text/html');
      const updated = parsed.querySelector('[data-tsyrk-cart]');
      if (!updated) throw new Error('The bag changed. Please reload to see its current contents.');
      root.innerHTML = updated.innerHTML;
      root.dataset.count = updated.dataset.count;
      document.querySelectorAll('[data-tsyrk-bag-count]').forEach((bag) => {
        bag.textContent = bag.textContent.replace(/\s+\d+$/, '') + ' ' + updated.dataset.count;
      });
      root.querySelector('[data-cart-status]').textContent = 'Your bag has been updated.';
      window.Shopify?.PaymentButton?.init?.();
      syncOptions();
      restoreOrder();
    };
    const operation = async (action) => {
      if (busy) return;
      busy = true;
      root.setAttribute('aria-busy', 'true');
      const error = root.querySelector('[data-cart-error]');
      error.hidden = true;
      try { await action(); await refresh(); }
      catch (failure) {
        if (failure.name !== 'AbortError') {
          root.querySelectorAll('[data-cart-item]').forEach((row) => { row.querySelector('[data-quantity-input]').value = row.dataset.quantity; });
          const message = root.querySelector('[data-cart-error]');
          message.textContent = failure.message;
          message.hidden = false;
          message.tabIndex = -1;
          message.focus({ preventScroll: false });
        }
      } finally { busy = false; root.removeAttribute('aria-busy'); }
    };
    const changeQuantity = (row, quantity) => operation(() => json('cart/change.js', { id: row.dataset.key, quantity }));
    const syncOptions = () => {
      root.querySelectorAll('[data-cart-item]').forEach((row) => {
        const data = itemData(row);
        row.querySelectorAll('[data-cart-option]').forEach((button) => {
          const options = [...data.options];
          options[Number(button.dataset.cartOption)] = button.dataset.value;
          button.disabled = !data.variants.some((variant) => variant.options.every((value, index) => value === options[index]));
        });
        const group = row.querySelector('[data-cart-linked-colors]');
        if (group) [...group.children].sort((a,b) => Number(a.dataset.colorOrder) - Number(b.dataset.colorOrder) || a.dataset.productId.localeCompare(b.dataset.productId)).forEach(button => group.append(button));
      });
    };
    const changeVariant = (row, button) => operation(async () => {
      const data = itemData(row);
      let variant;
      if (button.hasAttribute('data-cart-linked-color')) {
        const targetVariants = JSON.parse(button.dataset.targetVariants);
        const sizeIndex = data.optionNames.findIndex(name => name.toLowerCase() === 'size');
        const targetSizeIndex = Number(button.dataset.targetSizeIndex);
        const targetColorIndex = Number(button.dataset.targetColorIndex);
        variant = targetVariants.find(candidate =>
          (targetSizeIndex < 0 || sizeIndex < 0 || candidate.options[targetSizeIndex] === data.options[sizeIndex]) &&
          (targetColorIndex < 0 || candidate.options[targetColorIndex].trim().toLowerCase() === button.dataset.targetColor)
        );
      } else {
        const options = [...data.options];
        options[Number(button.dataset.cartOption)] = button.dataset.value;
        variant = data.variants.find((candidate) => candidate.options.every((value, index) => value === options[index]));
      }
      if (!variant) throw new Error('This size is not offered in the selected color. Your bag has not changed.');
      if (String(variant.id) === row.dataset.variantId) return;
      // An unavailable option is selectable for inspection, never converted into
      // a purchasable line or silently replaced with a different size.
      if (!variant.available) throw new Error('This size/color is sold out. Your bag has not changed.');
      const before = await json('cart.js');
      const original = before.items.find((item) => item.key === row.dataset.key);
      if (!original) throw new Error('This item has changed in another tab. Reload the bag before choosing a different option.');
      const payload = { id: variant.id, quantity: original.quantity, properties: original.properties || {} };
      if (original.selling_plan_allocation) payload.selling_plan = original.selling_plan_allocation.selling_plan.id;
      const added = await json('cart/add.js', { items: [payload] });
      const addedLine = added.items[0];
      try {
        await json('cart/change.js', { id: original.key, quantity: 0 });
        lineOrder = [...new Set(lineOrder.map(key => key === original.key ? addedLine.key : key))];
        saveOrder();
      } catch (failure) {
        const prior = before.items.find((item) => item.key === addedLine.key);
        try { await json('cart/change.js', { id: addedLine.key, quantity: prior?.quantity || 0 }); }
        catch { throw new Error('The new option was added, but the original item could not be removed. Please reload and review your bag before checkout.'); }
        throw failure;
      }
    });
    root.addEventListener('click', (event) => {
      if (busy) { if (event.target.closest('button, summary')) event.preventDefault(); return; }
      const row = event.target.closest('[data-cart-item]');
      if (!row) return;
      const step = event.target.closest('[data-quantity-step]');
      if (step) changeQuantity(row, Math.max(1, Number(row.dataset.quantity) + Number(step.dataset.quantityStep)));
      if (event.target.closest('[data-cart-remove]')) changeQuantity(row, 0);
      const option = event.target.closest('[data-cart-option], [data-cart-linked-color]');
      if (option && !option.disabled) changeVariant(row, option);
      const summary = event.target.closest('summary');
      if (summary) root.querySelectorAll('[data-cart-picker][open]').forEach((picker) => { if (picker !== summary.parentElement) picker.open = false; });
    }, { signal: controller.signal });
    root.addEventListener('change', (event) => {
      if (!event.target.matches('[data-quantity-input]')) return;
      const row = event.target.closest('[data-cart-item]');
      const quantity = Number(event.target.value);
      if (busy || !Number.isInteger(quantity) || quantity < 1) { event.target.value = row.dataset.quantity; return; }
      if (quantity !== Number(row.dataset.quantity)) changeQuantity(row, quantity);
    }, { signal: controller.signal });
    root.addEventListener('submit', (event) => { if (busy) event.preventDefault(); }, { signal: controller.signal });
    document.addEventListener('click', (event) => {
      root.querySelectorAll('[data-cart-picker][open]').forEach((picker) => { if (!picker.contains(event.target)) picker.open = false; });
    }, { signal: controller.signal });
    root.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const picker = event.target.closest('[data-cart-picker]');
      if (picker) { picker.open = false; picker.querySelector('summary').focus(); }
    }, { signal: controller.signal });
    root.cleanupCart = () => controller.abort();
    syncOptions();
    restoreOrder();
  };
  const prepare = (scope = document) => scope.querySelectorAll('[data-tsyrk-cart]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => prepare()); else prepare();
  document.addEventListener('shopify:section:load', (event) => prepare(event.target));
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-tsyrk-cart]').forEach((root) => root.cleanupCart?.()));
})();
